<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista organizacji</h4>
      <div>
        <b-button size="sm" @click="add">
          <span data-feather="plus"></span>
          Dodaj organizację
        </b-button>
      </div>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      empty-text="Brak organizacji"
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <template v-slot:cell(api_keys)="{ item }">
        {{
          JSON.parse(item.api_keys)
            .map(key => allowedApiKeys[key])
            .join(', ')
        }}
      </template>
      <template v-slot:cell(actions)="{ item }">
        <b-button class="btn-primary mr-1" size="sm" @click="edit(item)">Edytuj</b-button>
        <b-button class="btn-danger mr-1" size="sm" @click="remove(item)">Usuń</b-button>
      </template>
    </b-table>

    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Scopes',
  async mounted() {
    const vm = this
    await vm.fetchAllowedApiKeys()
    vm.listGroups()
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: 'Nazwa organizacji' },
        { key: 'api_keys', label: 'Lokalizacje w organizacji' },
        { key: 'created_at', label: 'Data utworzenia', sortable: true },
        { key: 'updated_at', label: 'Data ostatniej edycji', sortable: true },
        { key: 'actions', label: '' }
      ],
      currentPage: 1,
      totalRows: 0,
      perPage: 6,
      sortBy: '',
      sortDesc: false,
      allowedApiKeys: {}
    }
  },
  watch: {
    items() {
      this.updateUI()
    }
  },
  methods: {
    async fetchAllowedApiKeys() {
      const vm = this
      return vm.$http.post('e-zacma/get-allowed-api-keys').then(response => {
        const apiKeys = response.data
        // eslint-disable-next-line no-restricted-syntax
        for (const key of apiKeys) {
          vm.allowedApiKeys[key.api_key] = key.name
        }
      })
    },
    listGroups() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'list-scopes')
      vm.$http
        .post('e-zacma/list-scopes')
        .then(response => {
          vm.items = response.data
        })
        .catch(e => vm.$handleLaravelFormErrorResponse(e))
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'list-scopes')
        })
    },
    edit(item) {
      this.$router.push({ name: 'e-zacma-edit-scope', params: { id: item.scope_id } })
    },
    add() {
      this.$router.push({ name: 'e-zacma-add-scope' })
    },
    remove(item) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(
          `Czy na pewno chcesz usunąć organizacji "${item.name}"? Wynik tej operacji jest nieodwracalny.`,
          {
            title: 'Usuwanie organizacji',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Tak',
            cancelTitle: 'Nie',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            vm.$store.commit('addPageLoaderEvent', 'remove-scope')
            vm.$http
              .post('e-zacma/remove-scope', { id: item.scope_id })
              .then(response => {
                vm.listGroups()
                vm.$toast.success({
                  message: `Organizacja "${item.name}" została skasowana.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'remove-scope')
              })
          }
        })
    },
    updateUI() {
      this.totalRows = this.items.length
    }
  }
}
</script>
